import classNames from 'classnames/bind';
import styles from './JobsInProgressCompleted.module.scss';
import TableClassicReport from '../base/TableClassicReport';
import { useEffect, useState } from 'react';
import { IInProgressCompletedJobRecord, IPaginationReport } from '~/utils/interface/report';
import reportApi from '~/apis/report';
import { ColumnType } from '~/utils/types/common';
import dayjs from 'dayjs';

const cx = classNames.bind(styles);

const JobsInProgressCompleted = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IInProgressCompletedJobRecord[]>([]);
  const [pagination, setPagination] = useState<IPaginationReport>({
    totalItems: 0,
    totalPage: 0,
    page: 1,
    limit: 10,
    skip: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await reportApi.getJobsInProgressCompleteds({ page: pagination.page });
        setData(response.data?.data?.responses ?? []);
        setPagination(response.data?.data?.pagination ?? {
          totalItems: 0,
          totalPage: 0,
          page: 1,
          limit: 10,
          skip: 0,
        });
        setLoading(false);
      } catch (error) {
        console.error('Failed to fetch jobs in progress completed', error);
        setLoading(false);
      }
    };
    fetchData();
  }, [pagination.page]);


  const columns: Array<ColumnType> = [
    {
      id: "trade",
      labelHeader: "Trade",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.trade || "-"}</p>
        </div>
      ),
    },
    {
      id: "dateStatusChange",
      labelHeader: "Date Status Change",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{dayjs(job.dateStatusChanges).format("MM/DD/YYYY") || "-"}</p>
        </div>
      ),
    },
    {
      id: "name",
      labelHeader: "Name",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`${job.nameCustomer} - ${job.uniqueCode}`}</p>
        </div>
      ),
    },
    {
      id: "addressLine",
      labelHeader: "Address Line",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.addressLine || "-"}</p>
        </div>
      ),
    },
    {
      id: "zip",
      labelHeader: "Zip",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.zipCode || "-"}</p>
        </div>
      ),
    },
    {
      id: "shingleMfr",
      labelHeader: "Shingle Manufacturer",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.shingleManufacturer || "-"}</p>
        </div>
      ),
    },
    {
      id: "shingleColor",
      labelHeader: "Shingle Color",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.shingleColor || "-"}</p>
        </div>
      ),
    },
    {
      id: "recordType",
      labelHeader: "Record Type",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.recordType || "-"}</p>
        </div>
      ),
    },
    {
      id: "status",
      labelHeader: "Status",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.status || "-"}</p>
        </div>
      ),
    },
    {
      id: "salesRepName",
      labelHeader: "Sales Rep",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.saleRepName || "-"}</p>
        </div>
      ),
    },
    {
      id: "assignedTo",
      labelHeader: "Assigned To",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{job.assignedName || "-"}</p>
        </div>
      ),
    },
    {
      id: "related",
      labelHeader: "Related",
      renderCell: (job: IInProgressCompletedJobRecord) => (
        <div className={cx("cell")}>
          <p className={cx("text-content")}>{`${job.nameCustomer} #${job.uniqueCode}(Contact)`}</p>
        </div>
      ),
    },
  ];

  return (
    <TableClassicReport
      title="Jobs In Progress & Completed"
      columns={columns}
      data={data}
      page={pagination.page}
      totalPages={pagination.totalPage}
      totalItems={pagination.totalItems}
      itemsPerPage={pagination.limit}
      onPageChange={(page) => {
        setPagination({ ...pagination, page });
      }}
      isLoading={loading}
    />
  );
};

export default JobsInProgressCompleted;
